import {
    WineCellarPoseId,
    WineCellarDoorId,
    WineCellarNbDoorId,
    WineCellarSensDoorId,
    WineCellarOptionId,
    WineCellarShelfId,
    WineCellarNbBottleId,
    WineCellarRoomId,
} from '@core/constants/Shape';
import { WineCellarFunctionalityId } from '@core/constants/Option';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import {
    IFormFieldShape,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
    IFormFieldDimension,
    IFormInputType,
    IDimensionUnit,
    IFormFieldMultiSelector,
} from '../../../interfaces/Form';
import {
    allConcretes,
    allGlasses,
    allMetals,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsWineCellarPose: IFormFieldShape = {
    value   : undefined,
    options : [
        WineCellarPoseId.WineCellarBuiltIn,
        WineCellarPoseId.WineCellarFreeStanding,
    ],
    required: true,
};

export const fieldsWineDoorSens: IFormFieldShapeQuantities = {
    [WineCellarSensDoorId.WineCellarDoorOpenLeft]: {
        value : undefined,
        min   : 0,
        max   : 30,
    },
    [WineCellarSensDoorId.WineCellarDoorOpenRight]: {
        value : undefined,
        min   : 0,
        max   : 30,
    },
};

export const fieldsWineCellarDoor: IFormFieldShape = {
    value   : undefined,
    options : [
        WineCellarDoorId.WineCellarFullDoor,
        WineCellarDoorId.WineCellarGlassDoor,
    ],
    required: true,
};

export const fieldsWineCellarRoom: IFormFieldShape = {
    value   : undefined,
    options : [
        WineCellarRoomId.WineCellarCellar,
        WineCellarRoomId.WineCellarGarage,
        WineCellarRoomId.WineCellarOutside,
        WineCellarRoomId.WineCellarOther,
    ],
    required: true,
};

export const fieldsWineCellarOption: IFormFieldShapeQuantities = {
    [WineCellarOptionId.WineCellarTempPanel]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WineCellarOptionId.WineCellarLighting]: {
        value : undefined,
        min   : 0,
        max   : 20,
    },
    [WineCellarOptionId.WineCellarLock]: {
        value : undefined,
        min   : 0,
        max   : 2,
    },
};

export const fieldsWineCellarMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allMetals,
                ...allSolidWoods,
                ...allConcretes,
                ...allGlasses,
            ],
            [
                MaterialId.Steel,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.Iron,
                MaterialId.ThermoLaqueredBlack,
                MaterialId.ThermoLaqueredWhite,
                MaterialId.SheetMetal,
                MaterialId.Zinc,
                MaterialId.WroughtIron,
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Ebony,
                MaterialId.Spruce,
                MaterialId.Rubber,
                MaterialId.DriftWood,
                MaterialId.Poplar,
                MaterialId.Ipe,
                MaterialId.Padouk,
                MaterialId.Larch,
                MaterialId.Redcedar,
                MaterialId.Douglas,
                MaterialId.Iroko,
                MaterialId.BlackLocust,
                MaterialId.Garapa,
                MaterialId.ConcreteWaxed,
            ],
        ),
        required: true,
    },
};

export const fieldsShelfMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([
            ...allSolidWoods,
            ...allMetals,
        ],
        [
            MaterialId.Pine,
            MaterialId.WagonfloorDark,
            MaterialId.WagonfloorLight,
            MaterialId.OakOld,
            MaterialId.Walnut,
            MaterialId.Ash,
            MaterialId.AshOlive,
            MaterialId.Chestnut,
            MaterialId.Acacia,
            MaterialId.Mahogany,
            MaterialId.Elm,
            MaterialId.Alderwood,
            MaterialId.Birch,
            MaterialId.Maple,
            MaterialId.Teak,
            MaterialId.Wenge,
            MaterialId.Cherrywood,
            MaterialId.Ebony,
            MaterialId.Spruce,
            MaterialId.Rubber,
            MaterialId.DriftWood,
            MaterialId.Poplar,
            MaterialId.Ipe,
            MaterialId.Padouk,
            MaterialId.Larch,
            MaterialId.Redcedar,
            MaterialId.Douglas,
            MaterialId.Iroko,
            MaterialId.BlackLocust,
            MaterialId.Garapa,
            MaterialId.Steel,
            MaterialId.Rust,
            MaterialId.Brass,
            MaterialId.Iron,
            MaterialId.ThermoLaqueredBlack,
            MaterialId.ThermoLaqueredWhite,
            MaterialId.SheetMetal,
            MaterialId.Zinc,
            MaterialId.WroughtIron,
        ]),
        required: true,
    },
};

export const fieldsWineCellarShelf: IFormFieldShapeQuantities = {
    [WineCellarShelfId.WineCellarPresentationShelf]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WineCellarShelfId.WineCellarSlidingShelf]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [WineCellarShelfId.WineCellarStorageShelf]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

export const fieldsWineNbDoor: IFormFieldShapeQuantities = {
    [WineCellarNbDoorId.WineCellarDoorQuantity]: {
        value : undefined,
        min   : 0,
        max   : 30,
    },
};

export const fieldsWineNbBootle: IFormFieldShapeQuantities = {
    [WineCellarNbBottleId.WineCellarNbBottle]: {
        value : undefined,
        min   : 12,
        max   : 360,
        step  : 12,
    },
};

export const fieldsWineCellarDimension: IFormFieldDimension = {
    [FieldDimensionId.Width]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 200, max: 6000 },
        required     : true,
        defaultValue : 600,
    },
    [FieldDimensionId.Depth]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 300, max: 1400 },
        required     : true,
        defaultValue : 700,

    },
    [FieldDimensionId.Height]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 400, max: 3000 },
        required     : true,
        defaultValue : 1600,
    },
};

export const fieldsWineCellarHeightCeilingDimension: IFormFieldDimension = {
    [FieldDimensionId.HeightCeiling]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 500, max: 4000 },
        required     : true,
        defaultValue : 2000,
    },
};

export const fieldsWineCellarSquareMeter: IFormFieldDimension = {
    [FieldDimensionId.SquareMeter]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.SquareMeter,
        step         : 100,
        range        : { min: 100, max: 20000 },
        required     : false,
        defaultValue : 2000,
    },
};

export const fieldsWineCellarDegrees: IFormFieldDimension = {
    [FieldDimensionId.Degrees]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Degrees,
        step         : 100,
        range        : { min: -1000, max: 4000 },
        required     : false,
        defaultValue : 2000,
    },
};

export const fieldsWineCellarHumidity: IFormFieldDimension = {
    [FieldDimensionId.Humidity]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Humidity,
        step         : 100,
        range        : { min: 0, max: 10000 },
        required     : false,
        defaultValue : 3000,
    },
};

export const fieldsWineCellarMultiSelector: IFormFieldMultiSelector = {
    value   : undefined,
    options : [
        WineCellarFunctionalityId.WineCellarAging,
        WineCellarFunctionalityId.WineCellarService,
        WineCellarFunctionalityId.WineCellarMultifunction,
    ],
    required: true,
};
